import { render, staticRenderFns } from "./SalesDeliveryBillPreview.vue?vue&type=template&id=72fbbeaa&"
import script from "./SalesDeliveryBillPreview.vue?vue&type=script&lang=js&"
export * from "./SalesDeliveryBillPreview.vue?vue&type=script&lang=js&"
import style0 from "./SalesDeliveryBillPreview.vue?vue&type=style&index=0&id=72fbbeaa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports